/* eslint-disable prettier/prettier */
import moment from "moment";

import qs from "qs";
import axios from "axios";
import {
    _
} from "core-js";

import {
    BookingForm
} from "@/components/util/BookingForm.js";


axios.defaults.withCredentials = true;

export class RepeatService {

    constructor(rideTypes, repeatServiceModel, store) {

        this.rideTypes = rideTypes;

        this.store = store;
        this.repeatServiceModel = repeatServiceModel;

        this.loadingA = false;
        this.loadingB = false;
        this.loading = false;

        this.bulkActionError = null;

        if (repeatServiceModel.trip_a == null) {
            repeatServiceModel.trip_a = RepeatService.emptyRepeatTripDefinition(this.rideTypes, this.store);
            repeatServiceModel.trip_a.user = this.repeatServiceModel.user;

        } else {

            var bookingUser = BookingForm.jsonToBookingFormBookingUser({
                booking: this.repeatServiceModel.trip_a.repeat_trip_template,
                user: this.repeatServiceModel.user
            });

            repeatServiceModel.trip_a.repeat_trip_template = new BookingForm(this.rideTypes, {
                booking: bookingUser.booking,
                user: this.repeatServiceModel.user
            }, this.store);

            repeatServiceModel.trip_a.repeat_trip_template.getCustomer(this.repeatServiceModel.user.contact_number);

            repeatServiceModel.trip_a.day_of_week_times_list =
                RepeatService.populatePartialDayOfWeekArray(repeatServiceModel.trip_a.day_of_week_times_list);

        }

        if (repeatServiceModel.trip_b != null) {

            console.log("Populating Trip B");

            var bookingUser = BookingForm.jsonToBookingFormBookingUser({
                booking: this.repeatServiceModel.trip_b.repeat_trip_template,
                user: this.repeatServiceModel.user
            });

            repeatServiceModel.trip_b.repeat_trip_template = new BookingForm(this.rideTypes, {
                booking: bookingUser.booking,
                user: this.repeatServiceModel.user
            }, this.store);

            repeatServiceModel.trip_b.repeat_trip_template.getCustomer(this.repeatServiceModel.user.contact_number);

            repeatServiceModel.trip_b.day_of_week_times_list =
                RepeatService.populatePartialDayOfWeekArray(repeatServiceModel.trip_b.day_of_week_times_list);
        } else {
            repeatServiceModel.trip_b = null;
            console.log("No trip B");
        }

    }

    canAddReturnTrip() {
        return this.repeatServiceModel.trip_a.id != null;
    }

    hasReturnTrip() {
        return this.repeatServiceModel.trip_b != null;
    }

    clearRepeatTripDefinitionError(repeatTrip) {
        console.log("Clearing repeat trip errors!");

        repeatTrip.repeat_trip_template.errors = [];
        repeatTrip.date_span.errors = [];
        repeatTrip.day_of_week_times_errors = [];
    }


    handleRepeatTripDefinitionError(repeatTrip, errors) {
        console.log("Handling repeat trip errors!");

        repeatTrip.repeat_trip_template.errors = errors.repeat_trip_template == null ? [] : errors.repeat_trip_template;
        repeatTrip.date_span.errors = errors.date_span == null ? [] : errors.date_span;
        repeatTrip.day_of_week_times_errors = errors.day_of_week_times_list == null ? [] : errors.day_of_week_times_list;

        if (repeatTrip.day_of_week_times_errors.time != null) {
            alert("Time must be in format HH:MM");
        }

        // if (repeatTrip.day_of_week_times_errors.day_of_week != null) {
        //     alert("Time must be in format HH:MM");
        // }

        // day_of_week

    }

    addCreateReturnTrip() {

        var rsd = RepeatService.emptyRepeatTripDefinition(this.rideTypes, this.store);
        rsd.user = this.repeatServiceModel.user;

        rsd.repeat_trip_template.booking = JSON.parse(JSON.stringify(this.repeatServiceModel.trip_a.repeat_trip_template.booking));

        var booking = rsd.repeat_trip_template.booking;

        var pickup = booking.pickup_location;
        var destination0 = booking.destinations[0];

        var vias = booking.destinations.slice(1);

        booking.destinations.length = 0;
        booking.pickup_location = destination0;

        booking.destinations.push(pickup);

        if (vias != null) {
            vias.reverse();
            for (var i = 0; i < vias.length; i++) {
                booking.destinations.push(vias[i]);
            }
        }

        var pi = booking.pickup_info;
        booking.pickup_info = booking.destination_info;
        booking.destination_info = pi;

        rsd.date_span = JSON.parse(JSON.stringify(this.repeatServiceModel.trip_a.date_span));

        this.repeatServiceModel.trip_b = rsd;
        this.repeatServiceModel.trip_b.repeat_trip_template.getCustomer(this.repeatServiceModel.user.contact_number);
    }

    updateRepeatServiceModelTrips(newRepeatService) {
        if (this.repeatServiceModel.trip_a != null && newRepeatService.trip_a != null) {
            this.repeatServiceModel.trip_a.repeat_booking_entries = newRepeatService.trip_a.repeat_booking_entries;
            console.log(newRepeatService.trip_a.repeat_booking_entries);
            this.repeatServiceModel.trip_a.id = newRepeatService.trip_a.id;
            this.repeatServiceModel.trip_a.changes = newRepeatService.trip_a.changes;

        }

        if (this.repeatServiceModel.trip_b != null && newRepeatService.trip_b != null) {
            this.repeatServiceModel.trip_b.repeat_booking_entries = newRepeatService.trip_b.repeat_booking_entries;
            console.log(newRepeatService.trip_b.repeat_booking_entries);
            this.repeatServiceModel.trip_b.id = newRepeatService.trip_b.id;
            this.repeatServiceModel.trip_b.changes = newRepeatService.trip_b.changes;
        }
    }

    addRepeatTrip(outbound) {

        var repeatTripJSON = {};

        var repeatTrip;

        var url = `${this.store.state.apiUrl}/repeat_service/${this.repeatServiceModel.id}/${outbound ? "outbound" : "return"}`;

        if (outbound) {
            repeatTrip = this.repeatServiceModel.trip_a;
        } else {
            repeatTrip = this.repeatServiceModel.trip_b;
        }

        repeatTripJSON.date_span = repeatTrip.date_span;
        repeatTripJSON.day_of_week_times_list = repeatTrip.day_of_week_times_list;

        repeatTripJSON.repeat_trip_template = repeatTrip.repeat_trip_template.makeBookingJSON(repeatTrip.repeat_trip_template.booking);

        var vm = this;

        console.log(JSON.stringify(repeatTripJSON));

        if (outbound) {
            this.loadingA = true;
        } else {
            this.loadingB = true;
        }

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify(repeatTripJSON),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.doneLoading();

                if (res.data.error == "no_error") {
                    console.log(res.data);

                    vm.clearRepeatTripDefinitionError(repeatTrip);
                    vm.updateRepeatServiceModelTrips(res.data.repeat_service);

                } else {
                    if (res.data.message != null) {
                        alert(res.data.message);
                    } else if (res.data.errors != null) {
                        vm.handleRepeatTripDefinitionError(repeatTrip, res.data.errors);
                    } else if (res.data.error != null) {
                        alert(res.data.error);
                    }
                }
            })
            .catch(function (err) {

                alert("Unknown Error");

                vm.doneLoading();

                console.error(err);
            });
    }

    doneLoading() {
        this.loadingA = false;
        this.loadingB = false;
        this.loading = false;
    }

    updateRepeatTrip(outbound, notes) {

        var repeatTripJSON = {};

        var repeatTrip;

        var url = `${this.store.state.apiUrl}/repeat_service/${this.repeatServiceModel.id}/${outbound ? "outbound" : "return"}/update`;

        if (outbound) {
            repeatTrip = this.repeatServiceModel.trip_a;
        } else {
            repeatTrip = this.repeatServiceModel.trip_b;
        }

        repeatTripJSON.date_span = repeatTrip.date_span;
        repeatTripJSON.day_of_week_times_list = repeatTrip.day_of_week_times_list;

        repeatTripJSON.repeat_trip_template = repeatTrip.repeat_trip_template.makeBookingJSON(repeatTrip.repeat_trip_template.booking);

        var vm = this;

        console.log(JSON.stringify(repeatTripJSON));

        repeatTripJSON.reset_trips = repeatTrip.force == null ? false : repeatTrip.force;
        repeatTripJSON.recover_trips = repeatTrip.recover == null ? false : repeatTrip.recover;

        if (outbound) {
            this.loadingA = true;
        } else {
            this.loadingB = true;
        }

        repeatTripJSON.notes = ((notes == null || notes.length == 0) ? "Update Repeat Trip Definition" : notes);

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify(repeatTripJSON),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.doneLoading();

                if (res.data.error == "no_error") {
                    console.log(res.data);

                    vm.clearRepeatTripDefinitionError(repeatTrip);
                    vm.updateRepeatServiceModelTrips(res.data.repeat_service);

                } else {
                    console.log(res.data);

                    if (res.data.message != null) {
                        alert(res.data.message);
                    } else if (res.data.errors != null) {
                        vm.handleRepeatTripDefinitionError(repeatTrip, res.data.errors);
                    } else if (res.data.error != null) {
                        alert(res.data.error);
                    }
                }
            })
            .catch(function (err) {

                alert("Unknown Error");

                vm.doneLoading();

                console.error(err);
            });
    }

    resetDayOfWeekTimeList(repeatTrip, outbound) {
        var tRepeatTrip;

        if (outbound) {
            tRepeatTrip = this.repeatServiceModel.trip_a;
        } else {
            tRepeatTrip = this.repeatServiceModel.trip_b;
        }

        repeatTrip.day_of_week_times_list = JSON.parse(JSON.stringify(tRepeatTrip.day_of_week_times_list));
    }

    alterRepeatTrip(outbound, repeatTrip, amendType, notes) {

        var repeatTripJSON = {};

        var url = `${this.store.state.apiUrl}/repeat_service/${this.repeatServiceModel.id}/${outbound ? "outbound" : "return"}/alterTrips`;

        if (amendType == 0) {
            // shouldnt need to do anything really
        } else {
            // reset the trip time span
            // add the trips into the request

            var tRepeatTrip;

            var repeatBookingEntryIds = [];

            if (outbound) {
                repeatTrip.date_span = this.repeatServiceModel.trip_a.date_span;
                tRepeatTrip = this.repeatServiceModel.trip_a;
            } else {
                repeatTrip.date_span = this.repeatServiceModel.trip_b.date_span;
                tRepeatTrip = this.repeatServiceModel.trip_b;
            }

            if (tRepeatTrip != null) {
                tRepeatTrip.repeat_booking_entries.forEach(
                    function (t) {
                        if (t.booking.selected) {
                            repeatBookingEntryIds.push(t.id);
                        }
                    }
                );
            }

            console.log("Selected " + repeatBookingEntryIds.length + " bookings");

            if (repeatBookingEntryIds.length == 0) {
                alert("No trips selected");
                return;
            }

            repeatTripJSON.repeat_booking_entry_ids = repeatBookingEntryIds;

        }

        repeatTripJSON.notes = ((notes == null || notes.length == 0) ? "Alter Trips" : notes);

        repeatTripJSON.date_span = repeatTrip.date_span;
        repeatTripJSON.day_of_week_times_list = repeatTrip.day_of_week_times_list;

        repeatTripJSON.repeat_trip_template = repeatTrip.repeat_trip_template.makeBookingJSON(repeatTrip.repeat_trip_template.booking);

        var vm = this;

        console.log(JSON.stringify(repeatTripJSON));

        repeatTripJSON.reset_trips = repeatTrip.force == null ? false : repeatTrip.force;
        repeatTripJSON.recover_trips = repeatTrip.recover == null ? false : repeatTrip.recover;

        if (outbound) {
            this.loadingA = true;
        } else {
            this.loadingB = true;
        }

        axios({
            url: url,
            method: 'POST',
            data: JSON.stringify(repeatTripJSON),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.doneLoading();

                if (res.data.error == "no_error") {
                    console.log(res.data);

                    vm.clearRepeatTripDefinitionError(repeatTrip);
                    vm.updateRepeatServiceModelTrips(res.data.repeat_service);

                } else {
                    console.log(res.data);

                    if (res.data.error == "day_of_week_change_only") {
                        vm.resetDayOfWeekTimeList(repeatTrip, outbound);
                        alert(res.data.message);

                        return;
                    }

                    if (res.data.message != null) {
                        alert(res.data.message);
                    } else if (res.data.errors != null) {
                        vm.handleRepeatTripDefinitionError(repeatTrip, res.data.errors);
                    } else if (res.data.error != null) {
                        alert(res.data.error);
                    }
                }
            })
            .catch(function (err) {

                vm.doneLoading();

                alert("Unknown Error");

                console.error(err);
            });
    }

    applyBulkDateAction(date_span, return_selector, mode) {

        this.bulkActionError = null;

        var url = `${this.store.state.apiUrl}/repeat_service/${mode == 'cancel' ? 'cancelTripDateSpan' : 'recoverTripDateSpan'}`;

        url += `?repeat_service_id=${this.repeatServiceModel.id}`;
        url += `&start_date=${date_span.start_date}`;
        url += `&end_date=${date_span.end_date}`;

        if (return_selector == 0) {
            url += "&outbound=true";
        } else if (return_selector == 1) {
            url += "&outbound=false";
        }

        var vm = this;
        this.loading = true;

        axios({
            url: url,
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.doneLoading();

                if (res.data.error == "no_error") {
                    console.log(res.data);

                    vm.updateRepeatServiceModelTrips(res.data.repeat_service);

                } else {
                    alert(res.data.message);
                    console.log(res.data);
                }
            })
            .catch(function (err) {

                alert("Unknown error");
                vm.doneLoading();

                console.error(err);
            });
    }

    applyBulkSelectionAction(cancel) {

        this.bulkActionError = null;

        var url = `${this.store.state.apiUrl}/repeat_service/${cancel ? 'cancelTrips' : 'recoverTrips'}`;

        url += `?repeat_service_id=${this.repeatServiceModel.id}`;

        if (this.repeatServiceModel.trip_a != null) {
            this.repeatServiceModel.trip_a.repeat_booking_entries.forEach(
                function (t) {
                    if (t.booking.selected) {
                        url += `&repeat_trip_entry_id=${t.id}`;
                    }
                }
            );
        }

        if (this.repeatServiceModel.trip_b != null) {
            this.repeatServiceModel.trip_b.repeat_booking_entries.forEach(
                function (t) {
                    if (t.booking.selected) {
                        url += `&repeat_trip_entry_id=${t.id}`;
                    }
                }
            );
        }

        var vm = this;
        this.loading = true;

        axios({
            url: url,
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(function (res) {

                vm.doneLoading();

                if (res.data.error == "no_error") {
                    console.log(res.data);

                    vm.updateRepeatServiceModelTrips(res.data.repeat_service);

                } else {
                    alert(res.data.message);
                    console.log(res.data);
                }
            })
            .catch(function (err) {

                alert("Unknown error");
                vm.doneLoading();

                console.error(err);
            });
    }

    static emptyRepeatTripDefinition(rideTypes, store) {
        var empty = {
            id: null,
            day_of_week_times_list: RepeatService.emptyDayOfWeekArray(),
            date_span: RepeatService.emptyDateSpan(),
            repeat_trip_template: new BookingForm(rideTypes, "", store),
            repeat_booking_entries: [],
            day_of_week_times_errors: {},
        };

        empty.repeat_trip_template.booking.fixed_cost = true;
        empty.repeat_trip_template.booking.fixedCostType = empty.repeat_trip_template.FIXED_COST_DISPATCHER();

        return empty;
    }

    static days() {
        return [
            "MON",
            "TUE",
            "WED",
            "THU",
            "FRI",
            "SAT",
            "SUN"
        ];
    }

    static dayArray() {
        return ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    }

    static emptyDateSpan() {

        try {
            var now = new Date();

            var startDate = moment(now, "YYYY-MM-DD")
                .add(1, "days")
                .startOf('day')
                .toDate()
                .toISOString()
                .substr(0, 10);

            var endDate = moment(now, "YYYY-MM-DD")
                .add(8, "days")
                .startOf('day')
                .toDate()
                .toISOString()
                .substr(0, 10);

            return {
                start_date: startDate,
                end_date: endDate
            };
        } catch (e) {
            console.log(e);
        }
    }

    static emptyDayOfWeekArray() {
        return [{
            "day_of_week": "mon",
            "time": null
        }, {
            "day_of_week": "tue",
            "time": null
        }, {
            "day_of_week": "wed",
            "time": null
        }, {
            "day_of_week": "thu",
            "time": null
        }, {
            "day_of_week": "fri",
            "time": null
        }, {
            "day_of_week": "sat",
            "time": null
        }, {
            "day_of_week": "sun",
            "time": null
        }];
    }

    static populatePartialDayOfWeekArray(dayOfWeekArray) {
        var outputDayOfWeekArray = RepeatService.emptyDayOfWeekArray();

        for (var i = 0; i < dayOfWeekArray.length; i++) {
            var dow = dayOfWeekArray[i];

            outputDayOfWeekArray[RepeatService.dayArray().indexOf(dow.day_of_week)] = dow;
        }

        return outputDayOfWeekArray;
    }

    diffRepeatTripDefinitions(oldTripDefinition, newTripDefinition) {
        return ["X changed to Y"];
    }

}